export default __webpack_public_path__ + "static/media/03.3b1526bd.jpg";